/**
 * Bed catalogue.
 *
 * Types, options and their planner-relevant traits live in data, not in
 * `switch` statements: adding "queen" or "hammock" later is a new entry here
 * plus a migration, and every rule that consults these traits picks it up.
 */
export const BED_TYPES = ['single', 'double'];
export const BED_TYPE_DEFINITIONS = {
    single: { value: 'single', label: 'Single', defaultSizeCm: 90, sleeps: 1 },
    double: { value: 'double', label: 'Double', defaultSizeCm: 140, sleeps: 2 },
};
export const MIN_BED_SIZE_CM = 60;
export const MAX_BED_SIZE_CM = 250;
export function defaultSizeForBedType(type) {
    return BED_TYPE_DEFINITIONS[type].defaultSizeCm;
}
export function sleepsForBedType(type) {
    return BED_TYPE_DEFINITIONS[type].sleeps;
}
export function isBedType(value) {
    return typeof value === 'string' && BED_TYPES.includes(value);
}
//# sourceMappingURL=bedTypes.js.map